/**
 * Where Tab should land inside a modal dialog: `focusables` in DOM order, `active` the focused one (null when focus is outside the
 * dialog). Returns the element to focus when the move must wrap or come back inside, or null to let the browser move normally.
 */
export function NextTrapTarget<T>(focusables: readonly T[], active: T | null, shift: boolean): T | null {
    if (focusables.length === 0) return null;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (active === null || !focusables.includes(active)) return shift ? last : first;
    if (shift && active === first) return last;
    if (!shift && active === last) return first;
    return null;
}

/** The controls Tab can reach, for `NextTrapTarget`. */
export const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
